import axios from 'axios';
import { useDispatch } from 'react-redux';
import { loaderSlice, toasterSlice, routeSlice, accessTokenSlice } from 'redux/reducers';
import { useNavigate } from 'react-router-dom';
import * as AWS from 'aws-sdk';
import * as cryptoJS from 'crypto-js'
import { Buffer } from 'buffer'

const setClientTemplateHeader = client => {
	client.defaults.headers.common['e-id'] = process.env.REACT_APP_STANDALONE_APP !== 'Y' ? process.env.REACT_APP_E_ID : localStorage.getItem('c_id');
	client.defaults.headers.common['app-id'] = process.env.REACT_APP_STANDALONE_APP !== 'Y' ? 'COLLECTION_PORTAL' : 'CLIENT_PORTAL';
	return client;
};

export const request = async options => {
	try {
		let client = axios.create({ baseURL: options?.template ? process.env.REACT_APP_TEMPLATE_URL : process.env.REACT_APP_BASE_URL, headers: { c_id: localStorage.getItem('c_id'), token: localStorage.getItem('_ac') } });
		options?.refreshToken && (client.defaults.headers.common['refresh-token'] = localStorage.getItem('_rc'));
		options?.template && (client = setClientTemplateHeader(client));

		const response = await client(options);
		return Promise.resolve(response);
	} catch (error) {
		return Promise.reject(error.response);
	}
};

export const useFetch = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const handleToaster = value => {
		setStoreState({ key: 'TOASTER', value });
		setTimeout(() => {
			setStoreState({ key: 'TOASTER', value: null });
		}, 3000);
	};

	const setStoreState = e => {
		const obj = {
			LOADER: () => dispatch(loaderSlice.actions.loaderReducer(e?.value)),
			TOASTER: () => dispatch(toasterSlice.actions.toasterReducer(e?.value)),
			ROUTE: () => dispatch(routeSlice?.actions?.routeReducer(e?.value)),
			ACCESS_TOKEN: () => dispatch(accessTokenSlice?.actions?.accessTokenReducer(e?.value)),
			DEFAULT: () => null
		};
		(obj[e?.key] || obj['DEFAULT'])();
	};

	const api = async obj => {
		try {
			obj.method === 'delete' && obj?.data && delete obj?.data;
			setStoreState({ key: 'LOADER', value: true });
			obj.method !== 'get' && obj?.data && !(obj.data instanceof FormData) && process.env.REACT_APP_ENABLE_AWS_ENCRYPTION === 'Y' && await encryptRequest(obj);
			const res = await request(obj);
			setStoreState({ key: 'LOADER', value: false });
			obj?.successToaster && handleToaster({ header: 'Success!', success: true, content: res?.data?.data?.message || 'Yay! everything worked successfully' });
			if (res?.data?.data && Object.keys(res.data.data)?.find(elm => elm === 'encryptedKey') && process.env.REACT_APP_ENABLE_AWS_ENCRYPTION === 'Y') {
				res.data.data = await decryptResponse(res.data.data);
			}
			return Promise.resolve(res);
		} catch (error) {
			const err = error?.data?.message || error?.message || 'Something went wrong!';
			if (error?.status === 401) {
				setStoreState({ key: 'ACCESS_TOKEN', value: false });
			} else {
				!obj?.hideErrorToaster && handleToaster({ error: true, header: 'Error!', content: err });
				if (obj?.refreshToken) {
					setStoreState({ key: 'ROUTE', value: '' });
					navigate('');
				}
			}
			setStoreState({ key: 'LOADER', value: false });
			return Promise.reject(err);
		}
	};
	return api;
};

const kms = new AWS.KMS({
	accessKeyId: process.env.REACT_APP_ENCRYPTION_ACCESSKEY_ID,
	secretAccessKey: process.env.REACT_APP_ENCRYPTION_SECRET_ACCESSKEY,
	region: process.env.REACT_APP_ENCRYPTION_REGION,
});

const encryptRequest = async (obj) => {
	try {
		const key = await kms.encrypt({ KeyId: process.env.REACT_APP_ENCRYPTION_KMS_KEYID, Plaintext: process.env.REACT_APP_ENCRYPTION_SECRET_KEY }).promise();
		obj.data = {
			encryptedKey: key.CiphertextBlob.toString('base64'),
			encryptedBody: cryptoJS.AES.encrypt(JSON.stringify(obj.data), process.env.REACT_APP_ENCRYPTION_SECRET_KEY).toString()
		}
		return Promise.resolve(true);
	} catch (error) {
		return Promise.reject(error);
	}
}

const decryptResponse = async (res) => {
	try {
		const decryptParams = { CiphertextBlob: Buffer.from(res?.encryptedKey, 'base64'), KeyId: process.env.REACT_APP_ENCRYPTION_KMS_KEYID }
		const decryptedKey = await kms.decrypt(decryptParams).promise();
		const bytes = cryptoJS.AES.decrypt(res?.encryptedData, decryptedKey.Plaintext.toString('utf-8'));
		const decryptedData = bytes.toString(cryptoJS.enc.Utf8);
		return Promise.resolve(JSON.parse(decryptedData));
	} catch (error) {
		return Promise.reject(error);
	}
}